import React from "react";

const HomeServices = () => {

  const servicesData = [
    {
      title: "Digital Strategy and Planning",
      desc: "We leverage our years of experience to create the correct strategy and plans for your business which helps to grow your brand and revenue.",
    },
    {
      title: "Creative Strategy and Web Graphics Design",
      desc: "Creativity is a way of life at webeesocial. When we create something – a website, an app, emailer, an infographic, a social media post or..",
    },
    {
      title: "Social Media Marketing",
      desc: "Social is in our name, literally! Social Media is key to our overall strategy, and we use a variety of social strategies across different channels…",
    },
    {
      title: "Videos, GIFs and Content Marketing",
      desc: "Video has become the most popular content format. Google algorithm rewards pages with features such as social media integration...",
    },
    {
      title: "Website Design and Development",
      desc: "We stay ahead of the technological and UI trends. We focus on breaking down a user journey...",
    },
    {
      title: "Search Engine Optimization",
      desc: "Our approach to SEO and SEM is simple and transparent. We audit your assets...",
    },
    {
      title: "Email Marketing",
      desc: "We can build effective email marketing campaigns and streamline the delivery process...",
    },
    {
      title: "Web Analytics",
      desc: "Data driven marketing is most effective. Understanding analytics data is key...",
    },
    {
      title: "Media Planning and Buying",
      desc: "We are connected with a network of media partners who help us offer a fully integrated solution...",
    },
    {
      title: "Shopify Website & Development",
      desc: "Looking for a Shopify website development company? You’ve landed on just the right page!",
    },
  ];

  return (
    <section className="min-h-screen md:h-screen">
      <div className="grid grid-cols-1 md:grid-cols-3 h-full">

        {/* LEFT SIDE */}
        <div className="bg-gray-800 text-white p-6 sm:p-8 md:p-10 flex items-center justify-center">
          <div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-3 leading-tight">
              Our <br />
              <span className="text-[#f99728]">Services</span>
            </h2>
            <div className="w-16 sm:w-20 h-[2px] bg-white mb-4"></div>
          </div>
        </div>

        {/* RIGHT SIDE SCROLL */}
        <div className="md:col-span-2 h-full overflow-y-auto md:overflow-y-scroll snap-y md:snap-mandatory">

          {servicesData.map((item, index) => {
            if (index % 2 !== 0) return null;

            return (
              <div
                key={index}
                className="min-h-[60vh] md:h-[50vh] snap-start grid grid-cols-1 md:grid-cols-2"
              >
                {/* CARD 1 */}
                <div className="border p-6 sm:p-8 flex flex-col justify-center">
                  <h3 className="text-xl sm:text-2xl font-bold mb-3">
                    {item.title}
                  </h3>
                  <div className="w-16 sm:w-20 h-[2px] bg-[#f99728] mb-4"></div>
                  <p className="text-gray-600 text-sm sm:text-base mb-4">
                    {item.desc}
                  </p>
                  <button className="bg-[#f99728] text-white px-4 py-2 w-fit rounded-xl">
                    READ MORE
                  </button>
                </div>

                {/* CARD 2 */}
                {servicesData[index + 1] && (
                  <div className="border p-6 sm:p-8 flex flex-col justify-center">
                    <h3 className="text-xl sm:text-2xl font-bold mb-3">
                      {servicesData[index + 1].title}
                    </h3>
                    <div className="w-16 sm:w-20 h-[2px] bg-[#f99728] mb-4"></div>
                    <p className="text-gray-600 text-sm sm:text-base mb-4">
                      {servicesData[index + 1].desc}
                    </p>
                    <button className="bg-[#f99728] text-white px-4 py-2 w-fit rounded-xl">
                      READ MORE
                    </button>
                  </div>
                )}
              </div>
            );
          })}

        </div>
      </div>
    </section>
  );
};

export default HomeServices;